module.exports = "<h1 style=\"color:rgb(30, 218, 243)\">\n  warranties works!\n</h1>\n"